import(/* webpackMode: "eager", webpackExports: ["NationalCurriculumInsightsView"] */ "/vercel/path0/src/app/(core)/teachers/national-curriculum-insights/[[...segments]]/components/View.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["consentClient","getConsent"] */ "/vercel/path0/src/browser-lib/cookie-consent/consentClient.ts");
